<template>
<e-chart ref="chart" />
</template>

<script>
export default {
  name: 'TimePieChart',
  props: {
    data: {
      required: true,
      type: Array
    },
    name: {
      required: true,
      type: String
    }
  },
  methods: {
    render (isReal) {
      let {data, name} = this

      let chartOpt = {
        toolbox: {
          feature: {
            saveAsImage: {}
          },
          right: 10
        },
        legend: {
          type: 'scroll',
          top: 30,
          width: 300
        },
        tooltip: {
          trigger: 'item'
        },
        color: ['#3A9B21', '#487BFF', '#00FFFF', '#FFF44E', '#BD97EB', '#FF303D', '#FF58EB', '#9a60b4', '#ea7ccc'],
        series: [{
          type: 'pie',
          radius: ['40%', '60%'],
          label: {
            show: true,
            position: 'center',
            fontSize: '18',
            fontWeight: 'bold',
            formatter: function () {
              return name
            }
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          },
          data: data
        }]
      }

      this.$refs.chart.setOpt(chartOpt)
      this.$refs.chart.resize()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Data/TimingPieChart.vue